(() => {
  const initializeFadingAnnouncementBar = (root = document) => {
    const bar = root.querySelector ? root.querySelector('.fading-announcement-bar') : null;

    if (!bar || bar.dataset.initialized === 'true') {
      return;
    }

    const messages = Array.from(bar.querySelectorAll('.fading-announcement-message'));

    if (!messages.length) {
      return;
    }

    bar.dataset.initialized = 'true';

    let currentIndex = 0;
    let intervalId = null;

    const notifyHeightChange = () => {
      document.dispatchEvent(new CustomEvent('theme:announcement-height:changed'));
    };

    const showNextMessage = () => {
      messages.forEach((message, index) => {
        message.classList.remove('active', 'inactive');
        message.classList.add(index === currentIndex ? 'active' : 'inactive');
      });

      currentIndex = (currentIndex + 1) % messages.length;
      notifyHeightChange();
    };

    showNextMessage();

    if (messages.length > 1) {
      intervalId = window.setInterval(showNextMessage, 5000);
      bar._jrbAnnouncementInterval = intervalId;
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initializeFadingAnnouncementBar(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeFadingAnnouncementBar(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const bar = event.target.querySelector ? event.target.querySelector('.fading-announcement-bar') : null;

    if (bar && bar._jrbAnnouncementInterval) {
      window.clearInterval(bar._jrbAnnouncementInterval);
    }
  });
})();
